export default __webpack_public_path__ + "static/media/pen1.a08dcadd.svg";